export const UPDATE_APPLICATION_SETTINGS = 'update_application_settings';
export const ADD_MESSAGING_SERVICE = 'add_messaging_service';
export const UPDATE_MESSAGING_SERVICE = 'update_messaging_service';
export const REMOVE_MESSAGING_SERVICE = 'remove_messaging_service';
export const UPDATE_DESKTOP_NOTIFICATION = 'update_desktop_notification';
export const UPDATE_OTP_NOTIFICATION = 'update_otp_notification';
export const BACK_TO_DEFAULT = 'back_to_default';
